var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.handleContentClick($event)}}},[_c('v-card',{staticClass:"mx-auto contact-card"},[_c('div',{staticClass:"desktop-container",domProps:{"innerHTML":_vm._s(_vm.cms_page.html)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }